import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import TestPage from "./pages/TestPage.tsx";
import ResultPage from "./pages/ResultPage.tsx";
import MachadaloHeader from "../Header/Header.tsx";
import AiChatDetail from "../PublicChat/AiChatDetail.tsx";
 
const TestRoutes = () => {
  return (
    // <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}> 
    //   <MachadaloHeader /> 
    //   <div style={{ flex: 1, overflowY: "auto" }}>
        <Routes>
          <Route path=":testId" element={<TestPage />} />
          <Route path="result/:resultId" element={<ResultPage />} />
          <Route path="detail-ai-chat/:leadId" element={<AiChatDetail />} />
        </Routes>
    //   </div>
    // </div>
  );
};

export default TestRoutes;